/* eslint-disable comma-dangle */

export default {
    address: [
        'user-input',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [],
    'about-building': [
        'common/cadastral-number',
        'common/tax-number',
        'name-and-year-commercial-autocomplete-no',
        'about-object/total-area',
        'floors-count',
        'ceiling-height',
        'building-type',
        'condition-type',
        'has-furniture',
        'house-line-type',
        'commercial-class',
        'land',
        'building-status-type',
        'building-developer',
        'building-management-company',
        'additional-items',
        'lift-types',
        'common/input-type',
        'parking',
        'common/parking-places-count',
        'common/parking-price-monthly'
    ],
    'price-and-deal-terms': [
        'price-sale',
        'vat-type',
        'lease-assignment-checkbox',
        'agent-bonus'
    ]
};
